export default __webpack_public_path__ + "static/media/pp-background.afe27d55.jpg";